import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Menu , Grid } from 'semantic-ui-react';
import { browserHistory } from "react-router";

const styles = {
  menuContainer : {
    display : 'flex',
    alignItems : 'center',
    justifyContent : 'center',
    padding : '10px'
  },
  menu : {
    width : '95%'
  }
}

class PricingMenu extends Component {
  render() {
    const { string , priceTarget } = this.props;
    return (
      <Grid.Row>
        <Grid.Column style={styles.menuContainer}>
          <Menu widths={3} style={styles.menu}>
            <Menu.Item name={string['hardware']} active={priceTarget === 'hardware'} onClick={(e,{ name })=>browserHistory.push({ pathname : '/pricing' , query : { target : 'hardware' } })}/>
            <Menu.Item name={string['software']} active={priceTarget === 'software'} onClick={(e,{ name })=>browserHistory.push({ pathname : '/pricing' , query : { target : 'software' } })}/>
            <Menu.Item name={string['service']} active={priceTarget === 'service'} onClick={(e,{ name })=>browserHistory.push({ pathname : '/pricing' , query : { target : 'service' } })}/>
          </Menu>
        </Grid.Column>
      </Grid.Row>
    );
  }
}

function mapStateToProps(state) {
  return {
    string : state.preference.string
  }
}

export default connect(mapStateToProps,null)(PricingMenu)



/** WEBPACK FOOTER **
 ** ./src/containers/price/priceMenu.js
 **/